import { Suspense, lazy } from "react"
import { atom, useAtom, useSetAtom } from "jotai"

const LiFiWidgetModal = lazy(() => import('./LiFiWidgetModal'))

const atomWidget = atom({
  show: false,
  target: {
    name: '',
    address: '',
  },
  callback: () => {},
})

export const useAddFunds = () => {
  const setWidget = useSetAtom(atomWidget)

  const addFunds = (target: { name: string, address: string }, callback: () => void) => {
    setWidget({ show: true, target, callback })
  }

  return {
    addFunds,
  }
}

export const AddFundsProvider = ({ children }: { children: React.ReactNode }) => {
  const [widget, setWidget] = useAtom(atomWidget)

  const clear = () => {
    widget.callback()
    setWidget({
      show: false,
      target: {
        name: '',
        address: '',
      },  
      callback: () => {},
    })
  }

  return (
    <>
      {children}
      {widget.target.address && (
        <div className='fixed inset-0 z-50'>
          <div className="absolute inset-0 z-10 flex items-center justify-center scale-75 md:scale-100">
            <div 
              className='absolute inset-0 scale-150 bg-black/70' 
              onClick={() => {
                clear()
              }}
            />
            
            <Suspense fallback={null}>
              <LiFiWidgetModal
                targetName={widget.target.name}
                targetAddress={widget.target.address}
                onClose={clear}
              />
            </Suspense>
          </div>
        </div>
      )}
    </>
  )
}
